import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "base";

store.registerModule(moduleName, {
  namespaced: true,
  actions: {
    //获取基地列表;
    async getBaseSettingList({ commit }, payload) {
      let result = await api.get(
        `/api/FishBase?${queryString.stringify(payload)}`
      );
      return result.data;
    },
    async addBaseSetting({ commit }, payload) {
      // 添加基地设置
      let result = await api.post("/api/FishBase", payload);
      return result;
    },
    async deleteBaseSetting({ commit }, payload) {
      // 删除基地设置
      let result = await api.delete(`/api/FishBase/${payload}`);
      return result;
    },
    async getChangeBaseSetting(cc, payload) {
      // 获取编辑基地设置数据
      let result = await api.get(`/api/FishBase/${payload}`);
      return result.data;
    },
    async changeBaseSetting(bb, payload) {
      // 改变基地设置
      let result = await api.put("/api/FishBase", payload);
      return result;
    },
    //获取基地;(默认全部)
    async getAllBaseList() {
      let result = await api.get("/api/FishBase/KeyValue?");
      return result.data;
    },
    //获取基地;(不含全部默认值)---添加页面
    async getBaseList() {
      let result = await api.get("/api/FishBase/KeyValue?");
      return result.data;
    },
  },
});

export default moduleName;
